import "./Projects.css"
import Project1 from "./Images/Adidas.mp4"
import Project3 from "./Images/Acko.mp4"
import Project2 from "./Images/Lybrate.mp4"
export const Project=()=>{
    return (
        <div id="Projects">
        <div className="project component__space">
           <div className="heading">
               <h1 className="heading">Projects</h1>
               <div className="row">
                   <div className="col__3">
                   <div className="border">
                   <video className="videoTag" autoPlay="true" loop="true" muted="true" mcafee_wa_processedvideo="true" mcafee_wa_userplayed="true">
                   <source src={Project1} type="video/mp4"/>
                    </video>
                   <h2 className="head">Adidas Website Clone</h2>
                   <p className="desc">Adidas website is an e-commerce platform. It contains the latest version of Adidas brand item for women, men and kids like clothes, shoes face-masks and Flip-flops. 
                   <br/> <img  className="img" src="https://cdn-icons-png.flaticon.com/128/1051/1051277.png" alt="HTML"/>   
                   <img  className="img" src="https://cdn-icons-png.flaticon.com/128/732/732190.png" alt="CSS"/>  
                   <img  className="img" src="https://cdn-icons-png.flaticon.com/128/5968/5968292.png" alt="JS"/>                
                  </p>
                   <a href="https://github.com/BHAVANI-DASARI/Adidas-Clone" target="_blank"><button className="abtn">Github</button></a>
                   <a href="https://rohit753.github.io/Adidas-Clone/" target="_blank"><button className="abtn">Website</button></a>
                   <a href="https://medium.com/@dasaribhavani99/adidas-clone-4fda56883306" target="_blank"><button className="abtn">Medium</button></a>
                   </div>
                   </div>
                   <div className="col__3">
                   <div className="border">
                   <video className="videoTag" autoPlay="true" loop="true" muted="true"  mcafee_wa_processedvideo="true" mcafee_wa_userplayed="true">
                   <source src={Project2} type="video/mp4"/>
                    </video>
                   <h2 className="head">Lybrate Clone</h2>
                   <p className="desc">Lybrate is a website used to interact between Doctor's and patients. Here doctors and patients will interact in online platform.On these project along with me, four  more people are worked.
                   <br/>  <img  className="img" src="https://cdn-icons-png.flaticon.com/128/1051/1051277.png" alt="HTML"/>   
                   <img  className="img" src="https://cdn-icons-png.flaticon.com/128/732/732190.png" alt="CSS"/>  
                   <img  className="img" src="https://cdn-icons-png.flaticon.com/128/5968/5968292.png" alt="JS"/> 
                  
                    </p>
                   <a href="https://github.com/BHAVANI-DASARI/Lybrate_Clone_Project" target="_blank"><button className="abtn">Github</button></a>
                   <a href="https://selva658.github.io/Lybrate_Clone_Project/" target="_blank"><button className="abtn">Website</button></a>
                   <a href="https://librateclone.hashnode.dev/lybrate-clone-website-experience" target="_blank"><button className="abtn">Medium</button></a>
                   </div>
                   </div>
                   <div className="col__3">
                   <div className="border">
                   <video className="videoTag" autoPlay="true" loop="true" muted="true"  mcafee_wa_processedvideo="true" mcafee_wa_userplayed="true">
                   <source src={Project3} type="video/mp4"/>
                    </video>
                   <h2 className="head">Acko Insurance Clone</h2>
                   <p className="desc">Acko General Insurance is a private sector general insurance company in India. Acko operations for the company are offered through the digital platform.We five members worked on project collobratively.
                   <br/> <img  className="img" src="https://cdn-icons-png.flaticon.com/128/1260/1260667.png"/>   
                   <img  className="img" src="https://cdn-icons-png.flaticon.com/128/732/732190.png"/>  
                   {/* <img  className="img" src="https://cdn-icons-png.flaticon.com/128/5968/5968292.png"/>  */}
                   <img className="img" src="https://cdn-icons-png.flaticon.com/128/919/919825.png"/>
                   <img className="img" src="https://chiranjeev-thapliyal.vercel.app/svg/mongodb.svg"/>
                   </p>
                   <a href=" https://github.com/BHAVANI-DASARI/ackobike" target="_blank"><button className="abtn">Github</button></a>
                   <a href="https://acko-clone.netlify.app/" target="_blank"><button className="abtn">Website</button></a>
                   <a href=" https://medium.com/@dasaribhavani99/acko-insurance-e964c7eb3947" target="_blank"><button className="abtn">Medium</button></a>
                   {/* <a href="https://drive.google.com/file/d/1iZJcS6-5tctVjZ_tGRzGMJ_pSyXww63R/view?usp=sharing" target="_blank"><button className="abtn">DEMO</button></a> */}
                   </div>
                   </div>
               </div>
           </div>
        </div>
        </div>
    )
}
